import React from 'react';

import { Carousel } from '@/design-system/atoms/Carousel';
import { ContentContainer } from '@/design-system/atoms/ContentContainer';
import { Text } from '@/design-system/atoms/Text';
import { Title } from '@/design-system/atoms/Title';
import { ProviderCarouselCard } from '@/design-system/molecules/ProviderCarouselCard';
import cardStyles from '@/design-system/molecules/ProviderCarouselCard/ProviderCarouselCard.module.scss';

import styles from '../../ProviderCarousel.module.scss';

const MobileProviderCarousel = (props) => {
    const { title, cta, providers, showCta, location } = props;
    const providerCards = React.useMemo(() => {
        const providerCards = providers.map((doctor, index) => (
            <MobileProviderCarousel.Card fullHeight key={index}>
                <ProviderCarouselCard
                    {...doctor}
                    analytics={{ componentTitle: title, componentName: 'Doctor Carousel' }}
                    className={cardStyles[`provider-carousel-card`]}
                />
            </MobileProviderCarousel.Card>
        ));
        return providerCards;
    }, [providers, title]);

    return (
        <div className={styles[`provider-carousel__mobile`]}>
            {title && (
                <ContentContainer>
                    <div className={styles['provider-carousel__header']}>
                        <Title
                            tag={Title.TAG.H2}
                            variant={Title.VARIANT.H3}
                            content={title}
                            className={styles[`provider-carousel__title`]}
                        />

                        {location && (
                            <Text
                                tag="span"
                                variant="t2"
                                className={styles['featured-provider-carousel__location']}
                                content={`Located around ${location}`}
                            />
                        )}
                    </div>
                </ContentContainer>
            )}
            <Carousel.Root>
                <Carousel.Content items={providerCards} />
                <Carousel.Footer>
                    {showCta && (
                        <Carousel.CallToAction
                            {...cta}
                            analytics={{
                                componentName: 'Doctor Carousel',
                                componentTitle: title,
                            }}
                            className={styles[`provider-carousel__cta`]}
                        />
                    )}
                    <Carousel.Spacer />
                    <Carousel.Navigation
                        analytics={{
                            componentName: 'Doctor Carousel',
                            componentTitle: title,
                        }}
                    />
                </Carousel.Footer>
            </Carousel.Root>
        </div>
    );
};

MobileProviderCarousel.Card = Carousel.Card;

export default MobileProviderCarousel;
